var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sb-stage" }, [
      _c(
        "button",
        { staticClass: "sb-cta", attrs: { "aria-label": "Starte Bestellung" } },
        [
          _c("div", { staticClass: "content-wrapper" }, [
            _c("h2", { staticClass: "label" }, [
              _vm._v("STARTE"),
              _c("br"),
              _vm._v("BESTELLUNG"),
            ]),
            _c("div", { staticClass: "arrow" }, [_vm._v("→")]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }